type SplitScreenProps = {
  height?: number;
  width?: number;
  strokeColor?: string;
};

export function SplitScreen({ height = 24, width = 24, strokeColor = "currentColor" }: SplitScreenProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.33334 3H19.3333C20.4379 3 21.3333 3.89543 21.3333 5V19C21.3333 20.1046 20.4379 21 19.3333 21H5.33334C4.22877 21 3.33334 20.1046 3.33334 19V5C3.33334 3.89543 4.22877 3 5.33334 3Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14.3333 3V21" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
